export default function Termos() {
  return (
    <div className="bg-dark-900 min-h-screen">
      {/* Background Effects */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-neon-blue/20 rounded-full blur-[120px] animate-pulse-slow"></div>
        <div className="absolute top-1/3 right-1/4 w-96 h-96 bg-neon-purple/20 rounded-full blur-[120px] animate-pulse-slow" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="relative z-10">
        {/* Header */}
        <header className="border-b border-neon-blue/20 bg-dark-800/60 backdrop-blur-xl">
          <div className="container mx-auto px-4 md:px-6 py-6">
            <div className="flex items-center justify-between">
              <a href="/" className="text-2xl md:text-3xl font-black bg-gradient-to-r from-neon-blue to-neon-purple bg-clip-text text-transparent cursor-pointer">
                Freedom Experience
              </a>
              <a 
                href="/"
                className="flex items-center gap-2 text-gray-400 hover:text-neon-blue transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-arrow-left-line text-xl"></i>
                <span className="text-sm md:text-base">Voltar</span>
              </a>
            </div>
          </div>
        </header>

        {/* Content */}
        <div className="container mx-auto px-4 md:px-6 py-12 md:py-20">
          <div className="max-w-4xl mx-auto">
            <div className="bg-dark-800/60 backdrop-blur-xl border border-neon-blue/30 rounded-2xl md:rounded-3xl p-6 md:p-10 lg:p-12">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-6 md:mb-8">
                Termos de Uso
              </h1>

              <div className="space-y-6 md:space-y-8 text-gray-300">
                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">1. Aceitação dos Termos</h2>
                  <p className="text-sm md:text-base leading-relaxed">
                    Ao acessar e usar este site, você aceita e concorda em cumprir estes Termos de Uso. Se você não concordar com qualquer parte destes termos, não deve usar nosso site.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">2. Sobre o Freedom Experience</h2>
                  <p className="text-sm md:text-base leading-relaxed">
                    O Freedom Experience é um programa educacional presencial voltado para jovens de 8 a 17 anos, focado em desenvolver habilidades do futuro como Inteligência Artificial, Bitcoin, comunicação, estratégia e outras competências essenciais.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">3. Inscrições e Pagamentos</h2>
                  <p className="text-sm md:text-base leading-relaxed mb-3">
                    As inscrições estão sujeitas à disponibilidade de vagas. Os valores e formas de pagamento são apresentados no site e podem ser alterados sem aviso prévio.
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-sm md:text-base">
                    <li>O pagamento confirma a matrícula do aluno</li>
                    <li>Vagas são limitadas por turma</li>
                    <li>Cancelamentos devem ser solicitados por escrito</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">4. Responsabilidades do Aluno</h2>
                  <p className="text-sm md:text-base leading-relaxed mb-3">
                    O aluno deve:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-sm md:text-base">
                    <li>Trazer seu próprio notebook para as aulas</li>
                    <li>Comparecer pontualmente às aulas</li>
                    <li>Respeitar colegas, professores e o ambiente de aprendizado</li>
                    <li>Seguir as orientações dos instrutores</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">5. Propriedade Intelectual</h2>
                  <p className="text-sm md:text-base leading-relaxed">
                    Todo o conteúdo do curso, incluindo materiais didáticos, apresentações e recursos, são propriedade do Freedom Experience e protegidos por direitos autorais. É proibida a reprodução, distribuição ou uso comercial sem autorização prévia.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">6. Política de Reembolso</h2>
                  <p className="text-sm md:text-base leading-relaxed">
                    Solicitações de reembolso devem ser feitas por escrito e estão sujeitas à análise. Entre em contato através do email z@zulk.com.br para mais informações sobre nossa política de cancelamento.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">7. Limitação de Responsabilidade</h2>
                  <p className="text-sm md:text-base leading-relaxed">
                    O Freedom Experience não se responsabiliza por danos ou perdas de equipamentos pessoais trazidos pelos alunos. Recomendamos que os responsáveis contratem seguro adequado para os dispositivos.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">8. Alterações nos Termos</h2>
                  <p className="text-sm md:text-base leading-relaxed">
                    Reservamos o direito de modificar estes termos a qualquer momento. As alterações entrarão em vigor imediatamente após sua publicação no site.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">9. Contato</h2>
                  <p className="text-sm md:text-base leading-relaxed">
                    Para dúvidas sobre estes Termos de Uso, entre em contato através do email: <a href="mailto:z@zulk.com.br" className="text-neon-blue hover:text-neon-purple transition-colors duration-300">z@zulk.com.br</a>
                  </p>
                </section>

                <div className="pt-6 md:pt-8 border-t border-neon-blue/20">
                  <p className="text-xs md:text-sm text-gray-400">
                    Última atualização: Dezembro de 2024
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
